/**
 * Extract ID from Shopify GID string (all values after the last slash)
 * e.g. gid://shopify/Product/12345 => 12345
 */
module.exports = (gid) => gid?.match(/[^/]+$/i)[0];